import { END } from "redux-saga";
import { fork, put } from "redux-saga/effects";

import { auroraV2Saga } from "./features/auroraV2";
import { batterySizerSaga } from "./features/battery-sizer";
import { deckSaga } from "./features/deck";
import { designToolSaga } from "./features/design-tool";
import { designPortalSaga } from "./features/designPortal";
import { dialogsSaga } from "./features/dialogs";
import { drawModeSaga } from "./features/drawMode";
import { notificationsSaga } from "./features/notifications";
import { proposalSaga } from "./features/proposal";
import { proposalPreviewSaga } from "./features/proposalPreview";
import { roofImageSaga } from "./features/roofImage";
import { soloSaga } from "./features/solo";

function* rootSaga() {
  if (typeof window === "undefined") {
    yield put(END);
    return;
  }

  yield fork(deckSaga);
  yield fork(proposalSaga);
  yield fork(proposalPreviewSaga);
  yield fork(designPortalSaga);
  yield fork(auroraV2Saga);
  yield fork(soloSaga);
  yield fork(dialogsSaga);
  yield fork(roofImageSaga);
  yield fork(drawModeSaga);
  yield fork(notificationsSaga);
  yield fork(designToolSaga);
  yield fork(batterySizerSaga);
}

export default rootSaga;
